<app-search></app-search>
<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="title-color">
            <h1>LISTA NIVEL EDUCATIVO</h1>
        </div>
        <br />
        <!-- <div>
            <button id="" class="primary-button" (click)="create()">
                <span class="button-content">
                    <mat-icon>add_circle</mat-icon>Agregar nuevo
                </span>
            </button>
        </div> -->
        <br />
        <section class="table-container mat-elevation-z1" tabindex="0">
            <div class="table-adjustable">
                <table
                    mat-table
                    [dataSource]="
                        (asyncEducation | async)?.results ?? []
                            | paginate
                                : {
                                      id: 'server',
                                      itemsPerPage: limit,
                                      currentPage: page,
                                      totalItems: total
                                  }
                    "
                >
                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef>Acciones</th>
                        <td mat-cell *matCellDef="let education">
                            <div class="action-buttons">
                                <a
                                    (click)="updateEducation(education)"
                                    class="icon-button"
                                >
                                    <span class="material-symbols-outlined"
                                        ><mat-icon>edit</mat-icon></span
                                    >
                                </a>
                                <a
                                    (click)="eliminate(education)"
                                    appOnlysuperuser="/education"
                                    class="icon-button"
                                >
                                    <span class="material-symbols-outlined"
                                        ><mat-icon>delete</mat-icon></span
                                    >
                                </a>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="personalData">
                        <th mat-header-cell *matHeaderCellDef>Usuario</th>
                        <td mat-cell *matCellDef="let education">
                            {{ education.outsider?.identificationType }}
                            {{ education.outsider?.identificationCode }}
                            {{ education.outsider?.name }}
                            {{ education.outsider?.lastName }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="level">
                        <th mat-header-cell *matHeaderCellDef>Nivel</th>
                        <td mat-cell *matCellDef="let education">
                            {{ education.level }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="culturalKnowledge">
                        <th mat-header-cell *matHeaderCellDef>
                            Conocimiento cultural
                        </th>
                        <td mat-cell *matCellDef="let education">
                            {{ education.culturalKnowledge }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="nasaYuwe">
                        <th mat-header-cell *matHeaderCellDef>Nasayuwe</th>
                        <td mat-cell *matCellDef="let education">
                            {{ education.nasaYuwe }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="isIlliterate">
                        <th mat-header-cell *matHeaderCellDef>Es analfabeto</th>
                        <td mat-cell *matCellDef="let education">
                            {{ education.isIlliterate ? 'Sí' : 'No' }}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: showColumns"
                        class="highlight-row"
                    ></tr>
                </table>
            </div>
        </section>
        <pagination-controls
            (pageChange)="fetchEducation($event)"
            previousLabel="Anterior"
            nextLabel="Siguiente"
            id="server"
        ></pagination-controls>
    </div>
</div>
